import { createSelector } from "reselect";

const selectCurrentUser = state => state.oidc.user;
const selectUserInfo = state => state.userInfo;
const selectCurrentUserProfile = createSelector([selectCurrentUser], user => user?.profile);

export const selectCurrentUserName = createSelector([selectCurrentUserProfile], profile => profile?.name);

export const selectUserId = createSelector([selectUserInfo], user => user?.userId);
